// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__M1e_y","ranges":"BmiRanges_ranges__2qyio"};